import { useEffect, useState } from 'react'

// Sent by the Export button just before it prints, so charts can mount first.
export const PRINT_EVENT = 'ffpDashboard:print'

// True from the first time the page is about to print, and stays true, so
// charts nobody has scrolled to yet still mount (unanimated) for the printout.
export function usePrinting(): boolean {
  const [printing, setPrinting] = useState(false)

  useEffect(() => {
    if (printing) return undefined

    const onPrint = () => setPrinting(true)
    window.addEventListener(PRINT_EVENT, onPrint)
    window.addEventListener('beforeprint', onPrint)

    return () => {
      window.removeEventListener(PRINT_EVENT, onPrint)
      window.removeEventListener('beforeprint', onPrint)
    }
  }, [printing])

  return printing
}
